module.exports = __webpack_public_path__ + "static/media/ice-cream-cups.755d21fc.jpg";